import VueI18n from 'vue-i18n';
import { i18nConfig, defaultLocale } from './';
import Vue from 'vue';

Vue.use(VueI18n);
export { defaultLocale };
export default new VueI18n(i18nConfig);
